<template>
  <full-page ref="fullpage" :options="options" id="fullpage">
    <div class="section" :style="isLoading ? {visibility: 'visible'} : {visibility: 'hidden'}">
      <div class="gr-section-wrapper gr-section-wrapper-lg-row gr-sm-scrollable" :style="paddingTop">
        <div class="gr-content-container gr-scrollable gr-order-text">
          <div class="gr-text-container gr-text-container-lg-column px-4">
            <h1 class="gr-header-2">Haftungsauschluss / Disclaimer</h1>
                <div class="gr-p-container">
                  <p>
                    1. Inhalt des Onlineangebotes
                    Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
                  </p><p>
                    2. Verweise und Links
                    Bei direkten oder indirekten Verweisen auf fremde Webseiten ("Hyperlinks"), die außerhalb des Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern.
                    Der Autor erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der verlinkten/verknüpften Seiten hat der Autor keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten aller verlinkten /verknüpften Seiten, die nach der Linksetzung verändert wurden. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in vom Autor eingerichteten Gästebüchern, Diskussionsforen, Linkverzeichnissen, Mailinglisten und in allen anderen Formen von Datenbanken, auf deren Inhalt externe Schreibzugriffe möglich sind. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist.
                </p><p>
                    3. Urheber- und Kennzeichenrecht
                    Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht gestattet.
                </p><p>
                    4. Datenschutz
                    Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder geschäftlicher Daten (Emailadressen, Namen, Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens des Nutzers auf ausdrücklich freiwilliger Basis. Die Inanspruchnahme und Bezahlung aller angebotenen Dienste ist - soweit technisch möglich und zumutbar - auch ohne Angabe solcher Daten bzw. unter Angabe anonymisierter Daten oder eines Pseudonyms gestattet. Die Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben veröffentlichten Kontaktdaten wie Postanschriften, Telefon- und Faxnummern sowie Emailadressen durch Dritte zur Übersendung von nicht ausdrücklich angeforderten Informationen ist nicht gestattet. Rechtliche Schritte gegen die Versender von sogenannten Spam-Mails bei Verstössen gegen dieses Verbot sind ausdrücklich vorbehalten.
                </p><p>
                    5. Rechtswirksamkeit dieses Haftungsausschlusses
                    Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
                </p>
                </div>
                <gr-btn-lite text="zurück" backgroundColor="rose" @click.native="$routeBack()"></gr-btn-lite>
          </div>
        </div>
      </div>
    </div>
    <div class="section fp-auto-height">
      <AppFooter backgroundColor="rose"></AppFooter>
    </div>
  </full-page>
</template>

<script>

import 'fullpage.js/vendors/scrolloverflow'
import AppFooter from './../../layout/Footer'
import grBtnLite from '@/components/grBtnLite'
import { colors } from '@/config'

export default {
  name: 'Impressum',

  components: {
    grBtnLite,
    AppFooter
  },
  data () {
    return {
      options: {
        licenseKey: '95185C31-0387415E-A00FCDD6-E9FB6DEE',
        menu: '#menu',
        sectionsColor: [colors.rose],
        verticalCentered: false,
        scrollOverflow: true
      },
      isNewLoading: true,
      isImageLoading1: true,
      imgContainerHeight: 0,
      textContainerHeight: 0,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.isNewLoading = true
    this.setLoading(true)
  },
  mounted () {
    document.body.style.height = 'auto'
    this.handleResize()
  },
  beforeMount () {
    this.isNewLoading = false
    setTimeout(() => this.setLoading(false), 400)
  },
  beforeDestroy () {
    this.$store.commit('setHeader', true)
    // Clean up global styles that fullpage.js sets on html/body
    document.documentElement.style.overflow = ''
    document.documentElement.style.height = ''
    document.body.style.overflow = ''
    document.body.style.height = ''
    document.documentElement.classList.remove('fp-enabled')
  },
  computed: {
    paddingTop () {
      if (this.isDesktop) {
        return { padding: '50px 0 0 0 !important' }
      } else {
        return { padding: Math.round(this.$store.getters['dom/navBarHeight'] - 3) + 'px 0 0 0 !important' }
      }
    },
    isDesktop: function () {
      return this.$store.getters['dom/isDesktop']
    },
    isLoading: function () {
      return !this.$store.getters['loading/isLoadingApp']
    }
  },
  methods: {
    setLoading (isLoaded) {
      this.$store.commit('loading/SET_LOADING_APP', isLoaded)
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      if (this.window.width < 992) {
        this.imgContainerHeight = this.window.height * 0.35
        this.textContainerHeight = (this.window.height - 80) * 0.65
      } else {
        this.imgContainerHeight = this.window.height * 0.40
        this.textContainerHeight = (this.window.height - 110) * 0.60
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    margin-bottom: 10px;
  }

  b {
    font-weight: 500;
  }
  .gr-section-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .gr-text-container {
    line-height: 1.1;
    margin: 45px 0;
  }
  .gr-p-container {
    margin-bottom: 0.5rem;
  }
  p {
    font-size: 0.95em;
    line-height: 1.7;
  }
  @media(max-height: 820px) {
    .gr-scrollable {
      min-height: 700px !important;
    }
  }
  @media(min-width: 760px) {
    .gr-text-container-lg-column {
      max-width: 80vw;
      // prevent that on transition potential image below text-container moves
      min-height: 25vh;
    }
    .gr-p-container {
      margin-bottom: 1rem;
    }
  }

  @media(min-width: 760px) and (max-width: 1025px) {
    .gr-text-container {
      max-width: 80vw !important;
      min-height: 25vh !important;
    }

  }
  @media(max-width: 1023px) {
    .gr-scrollable {
      min-height: 700px !important;
    }
  }
  @media(min-width: $window-lg) {
    .gr-text-container-lg-column {
      min-height: 35vh;
    }
    .gr-section-wrapper-lg-row {
      flex-direction: row;
      justify-content: flex-start;
    }
    p {
      font-size: 1.1em;
    }
  }
</style>
